import {WrappingLink} from "./components/molecules/wrapping-link/wrapping-link";

// TODO: Rename the WrappingLink component to Link
export const Link = WrappingLink;
